import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 16.933 16.933"
    >
      <path
        fill="#ff9751"
        d="M1.322.53a.797.797 0 00-.793.792v7.674c0 .436.358.793.793.793h8.733a.796.796 0 00.792-.793V1.322a.797.797 0 00-.792-.793z"
        data-original="#ff9751"
      ></path>
      <path
        fill="#ff7f29"
        d="M10.281.566a.776.776 0 01.037.227v7.674a.796.796 0 01-.792.793H.793a.776.776 0 01-.227-.037c.1.325.4.566.756.566h8.733a.796.796 0 00.792-.793V1.322a.795.795 0 00-.566-.756z"
        data-original="#ff7f29"
      ></path>
      <path
        fill="#e4eff8"
        d="M4.232.53v2.91c0 .204.222.331.399.228l1.059-.61 1.058.61a.265.265 0 00.397-.228V.53zm6.615 5.027c-1.312 0-2.38 1.069-2.38 2.38s1.068 2.381 2.38 2.381c1.312 0 2.382-1.069 2.382-2.38s-1.07-2.381-2.382-2.381zM1.852 8.202c0 .354.53.354.53 0V6.88c0-.353-.53-.353-.53 0zm1.058 0c0 .354.53.354.53 0V6.88c0-.353-.53-.353-.53 0zm1.059 0c-.001.354.53.354.529 0V6.88c0-.353-.53-.353-.53 0z"
        data-original="#e4eff8"
      ></path>
      <path
        fill="#549ad4"
        d="M15.923 11.112h-1.685a.49.49 0 00-.48.501v4.29c0 .278.213.501.48.501h1.382c.266 0 .46-.224.48-.5l.303-4.29a.478.478 0 00-.48-.502z"
        data-original="#549ad4"
      ></path>
      <path
        fill="#3588cb"
        d="M15.922 11.112c.267 0 .5.224.481.501l-.303 4.29c-.02.277-.214.501-.48.501h-1.382a.49.49 0 01-.48-.5v-.029h1.332c.267 0 .461-.224.481-.5l.3-4.263z"
        data-original="#3588cb"
      ></path>
      <path
        fill="#ffc6a0"
        d="M3.494 10.846a.906.906 0 01.52.122l2.632 1.526a.768.768 0 01-.07-.32.8.8 0 01.814-.79h3.802l1.224.522h1.341v3.78h-1.26c-.481 0-2.163.718-3.124.718-1.194-.058-6.271-3.85-6.271-3.85a.916.916 0 01.392-1.708z"
        data-original="#ffc6a0"
      ></path>
      <path
        fill="#ffaf7a"
        d="M13.757 11.906v3.78h-1.26c-.481 0-2.163.718-3.124.718-.282-.014-.783-.24-1.38-.57.089.022.17.038.237.042 1.106 0 3.04-.795 3.593-.795h1.102v-3.175z"
        data-original="#ffaf7a"
      ></path>
      <circle
        cx="-15.042"
        cy="15.346"
        r="0.265"
        fill="#e4eff8"
        data-original="#e4eff8"
        transform="scale(-1 1)"
      ></circle>
      <path
        fill="#ffaf7a"
        d="M6.576 12.163c.184.325.536.547.938.547h2.61c.296.083.237.517-.07.52H7.43c-.534 0-.984-.39-1.063-.898l.28.162a.768.768 0 01-.07-.32v-.01z"
        data-original="#ffaf7a"
      ></path>
      <path
        fill="#ffc6a0"
        d="M3.494 10.846a.906.906 0 01.52.122l2.632 1.526a.768.768 0 01-.07-.32.8.8 0 01.814-.79h3.802l1.224.522h1.341v3.78h-1.26c-.481 0-2.163.718-3.124.718-1.194-.058-6.271-3.85-6.271-3.85a.916.916 0 01.392-1.708z"
        data-original="#ffc6a0"
      ></path>
      <path
        fill="#ffaf7a"
        d="M13.757 11.906v3.78h-1.26c-.481 0-2.163.718-3.124.718-.282-.014-.783-.24-1.38-.57.089.022.17.038.237.042 1.106 0 3.04-.795 3.593-.795h1.142v-3.175zm-3.632.804c.295.083.236.517-.07.52H7.429c-.534 0-.984-.39-1.063-.898l.28.162a.768.768 0 01-.07-.32v-.01c.184.324.536.546.938.546z"
        data-original="#ffaf7a"
      ></path>
      <path
        fill="#549ad4"
        d="M15.923 11.112h-1.949a.49.49 0 00-.48.501v4.29a.49.49 0 00.48.501h1.646c.266 0 .46-.224.48-.5l.303-4.29a.478.478 0 00-.48-.502z"
        data-original="#549ad4"
      ></path>
      <path
        fill="#e4eff8"
        d="M14.817 15.346a.265.265 0 00.264.264.265.265 0 00.265-.264.265.265 0 00-.265-.265.265.265 0 00-.264.265z"
        data-original="#e4eff8"
      ></path>
      <path
        fill="#3588cb"
        d="M15.922 11.112c.267 0 .5.224.481.501l-.303 4.29c-.02.277-.214.501-.48.501h-1.646a.49.49 0 01-.48-.5v-.029h1.596c.267 0 .461-.224.481-.5l.3-4.263z"
        data-original="#3588cb"
      ></path>
      <path
        fill="#c4dcf0"
        d="M10.847 5.557a2.384 2.384 0 00-2.38 2.38c0 .791.39 1.492.985 1.925a2.364 2.364 0 01-.456-1.395 2.384 2.384 0 012.38-2.381c.521 0 1.003.17 1.395.456a2.378 2.378 0 00-1.924-.985z"
        data-original="#c4dcf0"
      ></path>
      <path
        fill="#549ad4"
        d="M13.225 5.818a.265.265 0 00-.182.08l-2.195 2.194-.871-.871c-.25-.25-.625.125-.375.375l1.058 1.058a.265.265 0 00.375 0l2.381-2.38a.265.265 0 00-.191-.456z"
        data-original="#549ad4"
      ></path>
      <path
        fill="#c4dcf0"
        d="M6.616.53v2.91a.26.26 0 01-.036.131l.168.097a.265.265 0 00.397-.228V.53z"
        data-original="#c4dcf0"
      ></path>
      <path
        fill="#c4dcf0"
        d="M5.69 2.53l-1.06.609a.265.265 0 01-.398-.229v.53c0 .204.222.331.399.228l1.059-.61 1.058.61a.265.265 0 00.397-.228v-.53c0 .204-.221.33-.397.229z"
        data-original="#c4dcf0"
      ></path>
    </svg>
  );
}

export default Icon;
